import type { PocPageChangeType } from 'commons/types';
import { DEFAULT_PAGINATION_SIZES } from 'core/constants/constants';
import { useCallback, useState } from 'react';

// Below this the table footer hides the pagination control entirely, making the extra rows
// unreachable (POC-22309).
const DEFAULT_PAGE_SIZE = DEFAULT_PAGINATION_SIZES[0];

export const usePagination = (defaultPageSize: number = DEFAULT_PAGE_SIZE) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(defaultPageSize);

    const handlePageChange = useCallback(
        (event: PocPageChangeType) => {
            if (event.pageSize !== pageSize) {
                setPageSize(event.pageSize);
                setCurrentPage(1);
                return;
            }
            setCurrentPage(event.page);
        },
        [pageSize]
    );

    const resetPage = useCallback(() => setCurrentPage(1), []);

    return {
        currentPage,
        pageSize,
        apiPage: currentPage - 1,
        handlePageChange,
        resetPage,
    };
};
